<template>
  <div>
    <SubTitleView>{{ $t("profilePage.etablissement.contact") }}</SubTitleView>
    <AdresseView
      v-model="localEtablissement"
      :readonly="readonly"
      :with-pays="true"
      :validation-group="validationGroup"
      @change-address="updateEtablissementContact"
    />
    <InputWithValidation
      v-model="localEtablissement.courriel"
      rules="required|email"
      :label="$t(`profilePage.etablissement.courriel`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.courriel`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="courrielEtablissement"
      autocomplete="etablissementEmail"
      @manual-change="updateEtablissementContact"
    />
    <InputWithValidation
      v-model="localEtablissement.telephone"
      rules="required|validPhoneNumber"
      type="tel"
      :label="$t(`profilePage.etablissement.telephone`)"
      :placeholder="$t(`profilePage.etablissement.placeholder.telephone`)"
      :disabled="readonly"
      :group="validationGroup"
      vid="telephoneEtablissement"
      @manual-change="updateEtablissementContact"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import AdresseView from "@/views/commons/AdresseView.vue"
import SubTitleView from "@/views/commons/SubTitleView.vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"

export default defineComponent({
  name: "EtablissementContactDetails",
  components: {
    InputWithValidation,
    AdresseView,
    SubTitleView,
  },
  props: {
    etablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationGroup: {
      type: String,
      default: "",
    },
  },

  emits: ["update-etablissement"],
  data() {
    return {
      localEtablissement: { ...this.etablissement } as EtablissementDTO,
    }
  },
  watch: {
    etablissement: {
      handler(newVal: EtablissementDTO) {
        this.localEtablissement = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    updateEtablissementContact(): void {
      this.$emit("update-etablissement", this.localEtablissement)
    },
  },
})
</script>
